import {Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {RoleData, RoleScope} from '@/views/administration/roles/interfaces';
import {config} from 'vuex-module-decorators';
import {EntityModule} from './entityModule';
config.rawError = true;
/*
    Динамический модуль хранилища vuex для работы с ролями пользователей
*/

const moduleName = 'roleModule';

function transformGet(elem: any): RoleData {
  return {
    id: elem.id,
    name: elem.name,
    scopes: [],
  };
}

function transformCreateEdit(elem: any): RoleData {
  const scopes: RoleScope[] = elem.scopes.map((elem: any) => ({
    scope: elem.scope,
    scopeDescription: elem.scope_description,
    isRead: elem.is_read,
    isWrite: elem.is_write,
    scopeName: elem.scope_name,
  }));
  return {...elem, scopes};
}

function transformSave(model: RoleData): any {
  const scopes = model.scopes.map((elem: RoleScope) => ({
    scope: elem.scope,
    scope_description: elem.scopeDescription,
    is_read: elem.isRead,
    is_write: elem.isWrite,
    scope_name: elem.scopeName,
  }));
  return {...model, scopes};
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class RolesModule extends EntityModule {
  protected routeName = 'roles';

  get all(): RoleData[] {
    return (super.all as RoleData[]).sort((a, b) => a.name.localeCompare(b.name));
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    return super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: RoleData}> {
    return super.create(transformCreateEdit) as Promise<{data: RoleData}>;
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: RoleData}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: RoleData}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: RoleData) {
    return super.save(model, transformSave);
  }
}

export default getModule(RolesModule);
